import { configureStore, combineReducers } from '@reduxjs/toolkit';
import doughnutChartSlice from './slices/doughnutChartSlice';
import trendLinesSlice from './slices/trendLinesSlice';
import recommendationTableSlice from './slices/recommendationTableSlice';
import accordionDataSlice from './slices/AccordionDataSlice';
import recommendationDataSlice from './slices/RecommendationDataSlice';
import heatMapSlice from './slices/HeatMapSlice';
import entityTrendLine from './slices/entityTrendLineSlice';
import applicationDrillChart from './slices/ApplicationDrillChartSlice';
import applicationDrillHeatMap from './slices/ApplicationDrillHeatMapSlice';
import OverAllRiskScoreCardSlice from './slices/OverAllRiskScoreCardSlice';
import applicationWiseTrend from './slices/ApplicationWiseTrendSlice';
import DetailsPageStatusCardSlice from './slices/DetailsPageStatusCardSlice';
import RiskScoreCardSlice from './slices/RiskScoreCardSlice';
import environmentDrillChart from './slices/EnvironmentDrillChartSlice';
import environmentWiseTrend from './slices/EnvironmentwiseTrendSlice';
import environmentPageStatusCardSlice from './slices/EnvironmentPageStatusCardSlice';
import buttonSlice from './slices/ButtonsSlice';
import componentCardSlice from './slices/RiskComponentSlice';
import riskFilterSlice from './slices/RiskFilterSlice';
import operationsSlice from './slices/OperationCardSlice';
import ResourceDistribution from './slices/ResourceDistributionSlice';
import recommendationCardSlice from './slices/RecommendationComponentSlice';
import graphSlice from './component/store/access-graph-slice';
import spinnerSlice from './slices/SpinnerSlice';
import apiUrlSlice from './slices/ApiStateSlice';
import thunk from 'redux-thunk';
const combinedReducer = combineReducers({
  doughnutChart: doughnutChartSlice,
  trendLines: trendLinesSlice,
  recommendationTable: recommendationTableSlice,
  accordionData: accordionDataSlice,
  recommendationDataSlice: recommendationDataSlice,
  heatMapSlice: heatMapSlice,
  entityTrendLine: entityTrendLine,
  applicationDrillChart: applicationDrillChart,
  applicationDrillHeatMap: applicationDrillHeatMap,
  applicationWiseTrend: applicationWiseTrend,
  OverAllRiskScoreCardData: OverAllRiskScoreCardSlice,
  DetailsPageStatusCard: DetailsPageStatusCardSlice,
  RiskScoreCard: RiskScoreCardSlice,
  environmentDrillChart: environmentDrillChart,
  environmentWiseTrend: environmentWiseTrend,
  environmentPageStatusCardSlice: environmentPageStatusCardSlice,
  buttonSlice: buttonSlice,
  componentCardSlice: componentCardSlice,
  riskFilterSlice: riskFilterSlice,
  operationsSlice: operationsSlice,
  ResourceDistribution: ResourceDistribution,
  recommendationCardSlice: recommendationCardSlice,
  graph: graphSlice,
  spinner: spinnerSlice,
  apiUrl: apiUrlSlice
});

const rootReducer = (state, action) => {
  if (action.type === 'riskFilterSlice/toggleUnmount') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
  middleware: [thunk]
});